<template>
    <!-- <gofix-card title="Nature of Feedback" class="mb-0 heig-frame-child tree-view-properties" fullContent>
    </gofix-card> -->
    <b-row>
        <b-col md="3">
            <gofix-card title="Nature of Feedback" class="contractTree contractPropertyAria" v-bind:class="{'run-loading':isLoading}">
                <template slot="gofixCard:right_header">
                    <div class="d-flex justify-content-end align-items-center">
                        <b-button class="mr-3" @click="showModalDelNode" title="Delete" v-b-tooltip.hover>
                            <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                            </svg>
                        </b-button>
                        <b-button class="mr-3" :disabled="isCheck" @click="addChildNode" title="Create" v-b-tooltip.hover>
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                            </svg>
                        </b-button>
                    </div>
                </template>
                <div class="contenAbsolute">
                    <div class="tree-view-properties">
                        <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                            <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                        </tree>
                    </div>
                </div>
                
                <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.delete.open">
                    <div class="center">Are you sure you want to <br/>delete <strong>This Item</strong>?</div>
                    <b-button-group class="btn-group">
                        <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button>
                        <b-button class="custom-btn" :disabled="modals.delete.loading" @click="removeNode"> <b-spinner v-if="modals.delete.loading" small type="grow"></b-spinner> Yes</b-button>
                    </b-button-group>
                </b-modal>
            </gofix-card>
        </b-col>
        <b-col md="9" class="pl-md-0">
            <div class="boxShadow bg-white contractSCFaultType noOverflow mb-0 heig-frame-tab">
                <b-row>
                    <b-col md="9">
                        <div class="title sm text-dark pl-0">{{ nodeSelected && nodeSelected.text ? nodeSelected.text : '--' }}</div>
                    </b-col>
                    <b-col md="3">
                        <div class="flex-justify-end">
                            <gofix-button
                                class="mb-19"
                                label="Save"
                                @click="save"
                                :loading="isAction"
                                :disabled="!nodeSelected"></gofix-button>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <template v-if="!isRoot">
                        <b-col md="6">
                            <gofix-form-tree
                                label="Parents"
                                :options="dataparents"
                                placeholder="Try expanding any folder option..."
                                v-model="nodeParent"
                                :normalizer="normalizer"
                                :loadOptions="loadOptions"
                                search-nested>
                            </gofix-form-tree>
                        </b-col>
                    </template>
                    <b-col md="6">
                        <gofix-form-input label="Name" v-model="natureOfFeedback.name"></gofix-form-input>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>
<script>
    import { mapGetters } from 'vuex';
    import LiquorTree from 'liquor-tree'
    import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }

    export default {
        name: 'case-settings-nature-of-feedback',
        components: {
            [LiquorTree.name]: LiquorTree,
        },
        data () {
            return {
                isLoading: false,
                treeData: this.getData(),
                opts: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        node.isBatch = false;
                        if(node.data.id == this.rootId || !this.rootId) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }

                        return new Promise((resolve, reject) => {
                            this.$store.dispatch( 'CaseSettingsController/getTree', {
                                contract_id: this.$route.params.id,
                                id: node.data.id
                            }).then(response => {
                                resolve(response.data.data);
                            })
                        });
                    }
                },
                replace: function(key, value) {
                    switch (key) {
                        case "children":
                            if (value.length > 0) {
                                return value;
                            } else {
                                return null;
                            }
                            break;
                        default:
                            return value;
                    }
                },
                nodeSelected: null,
                dataparents: [],
                nodeParent: null,
                isCheck: false,
                rootId: 0,
                isRoot: true,
                modals: {
                    delete: {
                        open: false,
                        timer: null,
                        loading: false
                    }
                },
                isAction: false,
                natureOfFeedback: {
                    name: null
                }
            }
        },
        watch: {
            ClientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push('/v2/contract-client')
                }
                this.nodeSelected = null
                this.refreshTree();
            },
            rootId: function(val) {
                this.$refs.tree.$on('tree:mounted', (data) => {
                    this.$nextTick(() => {
                        let nodeRoot = this.$refs.tree.find({
                        data: {
                            id: this.rootId
                        }
                        });
    
                        nodeRoot[0].select();
                        this.select(nodeRoot[0]);
                        this.dataparents = this.$refs.tree.toJSON() ? JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace)) : [];
                    });
                })
                this.$refs.tree.$on('tree:data:received', (data) => {
                    this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                })
                this.$refs.tree.$on('node:selected', (data) => {
                    this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                })
            },
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        created() {},
        methods:{
            normalizer(node) {
                if (node.data && node.data.isBatch)
                    return {
                        isDisabled : (this.nodeSelected && this.nodeSelected.data.id == node.data.id) ? true : false,
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    }
                return {
                    isDisabled : (this.nodeSelected && this.nodeSelected.data && this.nodeSelected.data.id && this.nodeSelected.data.id == node.data.id) ? true : false,
                    id: node.data && node.data.id ? node.data.id : 0,
                    label: node.text,
                    children: undefined
                }
            },
            loadOptions({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return
                    };
                    if (parentNode.data.isBatch) {
                        global.axios(`api/contracts/${this.$route.params.id}/tree-nature-feedback/${parentNode.data.id}`, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            }
                        }).then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data
                                callback();
                            })
                        })
                    } else {
                        parentNode.children = []
                        callback();
                    }
                }
            },
            getData() {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch( 'CaseSettingsController/getTree', {
                        contract_id: this.$route.params.id,
                        id: 0
                    }).then(response => {
                        this.rootId = response.data.data[0].data.id;
                        resolve(response.data.data);
                    })
                });
            },
            refreshTree() {
                this.$store.dispatch( 'CaseSettingsController/getTree', {
                    contract_id: this.$route.params.id,
                    id: 0
                }).then(response => {
                    this.isRoot  = true
                    this.isCheck = false;
                    this.rootId  = response.data.data[0].data.id;

                    this.$nextTick(() => {
                        let nodeRoot = this.$refs.tree.find({
                        data: {
                            id: this.rootId
                        }
                        });
                        
                        if(nodeRoot[0]) {
                            nodeRoot[0].select();
                            this.select(nodeRoot[0], 0);
                        }
                    });
                    
                    this.$refs.tree.tree.setModel(response.data.data);
                })
            },
            async select(node, is_select_from_tree = 1){
                if(this.rootId !== node.data.id) this.isRoot = false;
                else this.isRoot = true;
                if(this.nodeSelected && this.nodeSelected.enabled()) {
                    this.nodeSelected.unselect();
                }
                
                if(!is_select_from_tree) {
                    let nodeObj = this.$refs.tree.find({
                        data: {
                            id: node.data.id
                        }
                    });

                    node = nodeObj[0];
                    node.select();
                }


                if (!node.data.parent_id) {
                    // getItem
                    let response = await this.$store.dispatch( 'CaseSettingsController/getItem', {
                        contract_id: this.$route.params.id,
                        id: node.data.id
                    })
                    delete response.data.data.children;
                    node.data = response.data.data
                }

                this.nodeSelected = node;
                this.nodeParent   = node.data.parent_id;
                this.natureOfFeedback.name = this.nodeSelected.text
                
            },
            addChildNode() {
                if(!this.dataparents) this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));

                let nodeObj = this.$refs.tree.find({
                    data: {
                        id: this.nodeSelected.data.id
                    }
                });
                
                var nodeSelected = nodeObj[0];
                var nodeNew = nodeSelected.append({
                    data: {
                        isBatch: false,
                        parent_id: nodeSelected.data.id,
                        node_type: null,
                        status: false
                    },
                    text: 'New node',
                });

                nodeSelected.expand();
                nodeNew.select();

                this.nodeParent = nodeSelected.data.id;
                this.select(nodeNew, 0);

                this.natureOfFeedback.name = 'New Node'

                // Fix disabled button, don't hide tooltips
                this.$root.$emit('bv::hide::tooltip');
            },
            showModalDelNode() {
                if (!this.nodeSelected) 
                    return this.$alertNotification("Please select a node", "danger");
                this.modals.delete.open = true;
            },
            removeNode() {
                this.modals.delete.loading = true;
                this.isCheck = true;
                if(this.nodeSelected.data && this.nodeSelected.data.id) {
                    this.$store.dispatch('CaseSettingsController/deteleItem', {
                        id: this.nodeSelected.data.id,
                        contract_id: this.$route.params.id
                    }).then(response=> {
                        this.isCheck = false;
                        if (this.nodeSelected && this.nodeSelected.data.id == this.rootId) {
                            this.refreshTree();
                        }
                    }).catch(err => {
                        this.isCheck = false;
                    })
                }

                if (this.nodeSelected.data.id == this.rootId) {
                    this.nodeSelected.children = [];
                    this.nodeSelected.unselect();
                } else {
                    this.nodeSelected.remove();
                }

                let nodeParent = this.$refs.tree.find({
                    data: {
                        id: this.nodeSelected.data.parent_id
                    }
                })

                if (nodeParent[0] && nodeParent[0].children && nodeParent[0].children.length == 0) {
                    nodeParent[0].data.isBatch = false;
                }

                this.select(nodeParent[0], 0);
                this.$alertNotification(this.$notificationV2('deleting', 'nature_of_feedback'));
                this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));

                this.nodeParent            = null;
                this.natureOfFeedback.name = '';
                this.modals.delete.loading = false;
                this.modals.delete.open    = false;
            },
            save() {
                if (!this.nodeParent && !this.isRoot)
                    return this.$alertNotification("Parent is a required field", "danger");
                if (!this.natureOfFeedback.name)
                    return this.$alertNotification("Name is a required field", "danger");

                let data = {
                    id:           this.nodeSelected.data && this.nodeSelected.data.id ? this.nodeSelected.data.id : null,
                    name:         this.natureOfFeedback.name.trim(),
                    parent_id:    this.nodeParent,
                    node_type:    null,
                    contract_id:  this.$route.params.id,
                };

                this.$store.dispatch(`CaseSettingsController/saveItem`, data)
                .then(result => {
                    let node_data  = result.data.data;
                    node_data.text = node_data.name;
                    let nodeParent = this.$refs.tree.find({
                        data: {
                            id: node_data.parent_id
                        }
                    })

                    this.isCheck = false;
                    delete node_data.children;
                    this.nodeSelected.data = node_data;
                    
                    if (this.nodeParent != node_data.parent_id && nodeParent) {
                        const nodeOld = this.nodeSelected;
                        this.nodeSelected.unselect();
                        this.nodeSelected.remove();
                        if (nodeParent && nodeParent[0]) {
                            if(!nodeParent[0].isBatch || nodeParent[0].expanded()) {
                                nodeParent[0].append(nodeOld);
                                nodeParent[0].data.isBatch = true;
                            }
                                
                            if(data.id) {
                                this.nodeParent = nodeParent[0].data.id;
                                nodeParent[0].expand();
                                nodeParent[0].select();
                                this.nodeSelected = nodeParent[0];
                            }
                        }
                    }

                    if(!data.id) {
                        this.isCheck = false;
                        this.nodeSelected.unselect();
                        if (nodeParent) {
                            let node = this.$refs.tree.selected();
                            node.unselect();
                            nodeParent[0].data.isBatch = true;
                            nodeParent.select(true)
                            this.nodeSelected = nodeParent[0];
                            this.select(nodeParent[0], 0);
                            this.nodeSelected.expand();
                        } else
                            this.nodeSelected = null;
                    }

                    this.isAction = false;
                    this.$alertNotification(this.$notificationV2(data.id ? 'editing' : 'adding', 'nature_of_feedback'));
                }).catch(err => {
                    this.isAction = false;
                })
            }
        }
    }
</script>
